import remote from '../remote'

const state = {
  invoiceconfigs: []
}

const getters = {
  INVOICECONFIGS: state => {
    return state.invoiceconfigs
  },
  INVOICECONFIG_BY_TYPE: (state, getters) => (type) => {
    return state.invoiceconfigs.find(config => config.type === type)
  }
}

const mutations = {
  SET_INVOICECONFIGS: (state, payload) => {
    state.invoiceconfigs = payload
  },
  SET_INVOICECONFIG: (state, config) => {
    state.invoiceconfigs = [
      ...state.invoiceconfigs.map(item => item.id !== config.id ? item : { ...item, ...config })
    ]
  }
}

const actions = {
  GET_INVOICECONFIGS: async (context, payload) => {
    let { data } = await remote().get('/api/invoiceconfig')
    context.commit('SET_INVOICECONFIGS', data)
  },
  SET_INVOICECONFIG: async (context, payload) => {
  }
}

export default {
  state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/modules/invoiceconfig.js